import { render, staticRenderFns } from "./FaceAccess.vue?vue&type=template&id=6390afe9&scoped=true"
import script from "./FaceAccess.vue?vue&type=script&lang=js"
export * from "./FaceAccess.vue?vue&type=script&lang=js"
import style0 from "./FaceAccess.vue?vue&type=style&index=0&id=6390afe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390afe9",
  null
  
)

export default component.exports